var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"topic_container"}},[_c('h3',[_vm._v(_vm._s(_vm.text ? _vm.text : _vm.initText))]),_c('h3',[_c('i',[_vm._v(_vm._s(_vm.question ? _vm.question : _vm.initQuestion))])])])}
var staticRenderFns = []

export { render, staticRenderFns }